// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import BusinessMgr from './components/ManagerModules/BusinessMgr'
import RuleInfo from './components/ManagerModules/RuleInfo'
import ComplaintInfo from './components/ManagerModules/ComplaintInfo'
import BusinessDetail from './components/ManagerModules/BusinessDetail'
import ComplaintDetail from './components/ManagerModules/ComplaintDetail'
import RuleDetail from './components/ManagerModules/RuleDetail'
import MainPage from './components/MainPage'
import ProductMgr from './components/BusinessModules/ProductMgr'
import ProductDetail from './components/BusinessModules/ProductDetail'
import MemberMgr from './components/BusinessModules/MemberMgr'
import CredentialDetail from './components/BusinessModules/CredentialDetail'
import ComplaintAction from './components/BusinessModules/ComplaintAction'
import SearchPage from './components/SearchPage'
import LoginPage from './components/LoginPage'
import StartPage from './components/StartPage'
import ShowImgPage from './components/ShowImgPage'
import CenterPage from './components/WholeSaleCenter/CenterPage'
import Mobile from './components/WholeSaleCenter/Mobile'
import PC from './components/WholeSaleCenter/PC'
import ProductPage from './components/WholeSaleCenter/ProductPage'
import global_ from './GLOBAL'//引用文件
//导入elementUI
import ElementUI from "element-ui"
//导入element css
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(VueRouter)
Vue.use(ElementUI);

Vue.prototype.$equipment=function(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
   return flag;
}

const routes = [{
  path: '/MainPage',
  component: MainPage   
},{
  path: '/BusinessMgr',
  component: BusinessMgr   
},
{
  path: '/RuleInfo',
  component: RuleInfo   
},
{
  path: '/ComplaintInfo',
  component: ComplaintInfo   
},
{
  path: '/BusinessDetail',
  component: BusinessDetail   
},
{
  path: '/RuleDetail',
  component: RuleDetail   
},
{
  path: '/ComplaintDetail',
  component: ComplaintDetail   
},
{
  path: '/ProductMgr',
  component: ProductMgr   
},
{
  path: '/ProductDetail',
  component: ProductDetail   
},
{
  path: '/MemberMgr',
  component: MemberMgr   
},
{
  path: '/CredentialDetail',
  component: CredentialDetail   
},
{
  path: '/ComplaintAction',
  component: ComplaintAction   
},
{
  path: '/SearchPage',
  component: SearchPage   
},
{
  path: '/LoginPage',
  component: LoginPage   
},
{
  path: '/ShowImgPage',
  component: ShowImgPage   
},
// {
//   path: '/',
//   component: StartPage   
// }
{
  path: '/Manager',
  component: ProductPage   
},
{
  path: '/Mobile',
  component: Mobile   
},
{
  path: '/PC',
  component: PC   
},
{
  path: '/',
  component: CenterPage   
}]

const router = new VueRouter({
  routes
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    // 注册全局事件总线$bus
    Vue.prototype.$bus = this
    Vue.prototype.GLOBAL = global_//挂载到Vue实例上面
  }
}).$mount('#app-box')




// WEBPACK FOOTER //
// ./src/main.js